(ns dre.components.search-results.annotations
  (:require
   ["antd" :refer [Popover]]
   [applied-science.js-interop :as j]
   [clojure.string :as str]
   [cljs.reader :as edn]
   [dre.components.subject :as subject]
   [dre.pages.search.events :as search-events]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [reagent.dom :as dom]
   [reagent.format :refer [format]]
   [taoensso.timbre :refer-macros [warn]]))

(defn sanitize-attr-val
  [o]
  (let [s (str o)]
    (if-not (str/blank? s)
      (str/replace s "&" "&amp;")
      s)))

(defn- ->start-tag
  [{:keys [type phrase subject-id]}]
  (case type
    :bold "<strong>"
    (let [class (case type
                  "i" "interventions"
                  "c" "characteristics"
                  "o" "outcomes"
                  "misc")]
      (format "<span class='pico %s' data-phrase='%s' data-subject='%s' data-active='false'>"
              class
              (sanitize-attr-val phrase)
              (sanitize-attr-val subject-id)))))


(defn- ->end-tag
  [{:keys [type]}]
  (case type
    :bold "</strong>"
    "</span>"))

(defn annotate-popover
  ([phrase inner search-query]
   (annotate-popover phrase inner search-query false))
  ([phrase inner search-query bold?]
  [:> Popover
   {:content (r/as-element [subject/phrase
                            (mapv (fn [[sense title is-suggestion]]
                                    {:sense sense
                                     :label title
                                     :is-suggestion is-suggestion})
                                  phrase) search-query])
    :trigger :click}
   (if bold?
     [:span
      [:strong {:dangerouslySetInnerHTML
                {:__html inner}}]]
     [:span
      {:dangerouslySetInnerHTML
       {:__html inner}}])]))


(defn wrap-popovers
  [element search-query]
  (doseq [el (seq (.getElementsByClassName element "pico"))]
    (let [s (j/get-in el [:dataset :phrase])]
      (when-not (str/blank? s)
        (try
          (let [phrase (edn/read-string s)
                subject-id (j/get-in el [:dataset :subject])
                _ (j/assoc! el :onmouseenter (fn [e]
                                               (doseq [el (seq (.getElementsByClassName element "pico"))]
                                                 (when (= (j/get-in el [:dataset :subject]) subject-id)
                                                   (j/assoc-in! el [:dataset :active] "true")))))
                _ (j/assoc! el :onmouseleave (fn [e]
                                               (doseq [el (seq (.getElementsByClassName element "pico"))]
                                                 (j/assoc-in! el [:dataset :active] "false"))))
                inner (.-innerHTML el)]
            (dom/render [annotate-popover phrase inner search-query] el))
          (catch :default e
            (warn "Error parsing wrap-popovers" s e)))))))

(defn replace-newlines
  [str-vec]
  (mapv #(if (= % "\n")
           "<br/>"
           %)
        str-vec))

(defn annotate
  ([text boldings picos]
   [annotate text boldings picos false nil nil])
  ([text boldings picos from to]
   [annotate text boldings picos false from to])
  ([text boldings picos preformatted?]
   [annotate text boldings picos preformatted? nil nil])
  ([_text _boldings _picos _preformatted? _ _]
   (let [element (r/atom nil)
         search-query @(rf/subscribe [::search-events/search-query])]
     (r/create-class
      {:display-name
       "annotated-text"

       :component-did-mount
       #(wrap-popovers @element search-query)

       :component-did-update
       #(wrap-popovers @element search-query)

       :component-will-update
       #(doseq [el (seq (.getElementsByClassName @element "pico"))]
          (dom/unmount-component-at-node el))
       
       :component-will-unmount
       #(doseq [el (seq (.getElementsByClassName @element "pico"))]
          (dom/unmount-component-at-node el))

       :reagent-render
       (fn [text boldings picos preformatted? from to]
         (let [text' text
               from (or from 0)
               to (or to (count text))
               text (subs text from to)
               triml (max 0 (.search text #"\S"))
               offset (+ from triml)
               text (subs text triml)
               annotated (atom (replace-newlines (vec text))
                               #_(if preformatted?
                                   (replace-newlines (vec text))
                                   (vec text)))]
           (doseq [[a b] boldings]
             (when (and (<= offset a)
                        (>= to b))
               (let [a (- a offset)
                     b (- b offset)]
                 (swap! annotated assoc a (str (->start-tag {:type :bold}) (@annotated a)))
                 (swap! annotated assoc (dec b) (str (@annotated (dec b)) (->end-tag {:type :bold}))))))

           (doseq [[a b data] picos]
             (when (and (<= offset a)
                        (>= to b))
               (let [a (- a offset)
                     b (- b offset)]
                 (swap! annotated assoc a (str (->start-tag data) (@annotated a)))
                 (swap! annotated assoc (dec b) (str (@annotated (dec b)) (->end-tag data))))))

           [:<>
            (when (> from 0)
              "…")
            [:span
             {:ref #(reset! element %)
              :dangerouslySetInnerHTML
              {:__html (apply str @annotated)}}]
            (when (< to (count text'))
              "…")]))}))))
